import React from "react";
import { Checkbox, RaisedButton, TextField } from "material-ui";
import { Link } from "react-router";
import Radium from "radium";

import TextSmsIcon from "material-ui/svg-icons/communication/textsms";

import LinkLike from "./link-like.jsx";
import PhoneField from "./phone-field.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../../actions/PersonActions";
import PersonStore from "../../stores/PersonStore";

@connectToStores
class SmsTicketsWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sms_tickets_enabled: undefined,
      phone_number: "",
      optinIsChecked: false,
    };

    this._enable = this._enable.bind(this);
    this._disable = this._disable.bind(this);
  }

  static contextTypes = {
    tenant: React.PropTypes.object,
    muiTheme: React.PropTypes.object
  };

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  componentDidMount() {
    this.setState({
      sms_tickets_enabled: this.props.details.sms_tickets_enabled,
      phone_number: this.props.details.phone_number
    });
  }

  _enable() {
    this.setState({ sms_tickets_enabled: true });
    PersonActions.edit({
      sms_tickets_enabled: true,
      phone_number: this.state.phone_number
    });
  }

  _disable() {
    this.setState({ sms_tickets_enabled: false });
    PersonActions.edit({
      sms_tickets_enabled: false
    });
  }

  getStyles() {
    return {
      container: {
        display: "flex",
        alignItems: "center",
        border: "1px solid #ccc",
        padding: "1em",
        marginTop: "1em",
        minHeight: 96,
        boxSizing: "border-box"
      },
      icon: {
        width: 60,
        height: 60,
        marginRight: "1em"
      }
    };
  }

  render() {
    let styles = this.getStyles();

    // SMS tickets disabled
    if (!this.context.tenant.sms_tickets_enabled) {
      return null;
    }

    return (
      <div style={styles.container}>
        <TextSmsIcon
          style={styles.icon}
          color={
            this.state.sms_tickets_enabled
              ? this.context.muiTheme.palette.accent1Color
              : "rgba(0,0,0,0.54)"
          }
        />
        <div>
          {this.state.sms_tickets_enabled ? (
            <div>
              <div>
                Your tickets will be sent via text message to{" "}
                {this.state.phone_number} an hour before showtime.
              </div>
              <div style={{ fontSize: "0.8em" }}>
                <LinkLike
                  style={{ color: "rgb(33,33,33)" }}
                  onClick={this._disable}
                >
                  Disable text message tickets / change phone number
                </LinkLike>
              </div>
            </div>
          ) : (
            <div>
              <div>
                Want to receive your tickets delivered directly to your phone
                via text message?
              </div>
              <div style={{ margin: "-5px 0" }}>
                Phone number:
                <PhoneField
                  autoFocus
                  hintText="(123) 456-7890"
                  value={this.state.phone_number}
                  style={{
                    width: 128,
                    marginRight: "1em",
                    marginLeft: "0.5em"
                  }}
                  onChange={e =>
                    this.setState({ phone_number: e.target.value })
                  }
                />
                <div style={{ paddingBottom: 10 }}>
                  <Checkbox
                    value={this.state.optinIsChecked}
                    label="By checking this box, you agree to receive ticket links, event reminders, and voting reminder alert messages from Eventive at the number provided."
                    onClick={e => {
                      console.log(e.target.checked)
                      this.setState({ optinIsChecked: e.target.checked })
                    }}
                  />
                </div>
                <div style={{ paddingBottom: 10 }}>
                  <RaisedButton
                    primary={true}
                    disabled={
                      !this.state.optinIsChecked ||
                      !this.state.phone_number ||
                      this.state.phone_number.replace(/[^\d]/g, "").length === 0
                    }
                    label="Enable text message tickets"
                    onClick={this._enable}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default SmsTicketsWidget;



// WEBPACK FOOTER //
// ./src/app/components/partials/sms-tickets-widget.jsx